import { useContext } from "react";
import { SegmentContext } from "../contexts/segment/SegmentContext";
import { AnalyticsBrowser } from "@segment/analytics-next";

export const useSegment = (): AnalyticsBrowser | null => {
  return useContext(SegmentContext);
};
